import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { InventoryOutputDetailModel } from 'src/app/models/inventory/inventory-output-detail.model';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InventoryOutputDetailCaptureTableModel } from 'src/app/models/tables/inventory/inventory-output-detail-capture-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalesRemissionDetailService {

  constructor(private _httpClient: HttpClient) { }

  createSalesRemissionDetail(inventoryOutputDetailContract: InventoryOutputDetailModel): Observable<InventoryOutputDetailModel> {
    return this._httpClient.post<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.CreateSalesRemissionDetail}`,
      inventoryOutputDetailContract);
  }

  createSomeDetails(rentalStocks: Array<InventoryOutputDetailModel>): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.CreateSomeDetails}`, rentalStocks);
  }

  deleteSalesRemissionDetail(inventoryOutputDetailId: number): Observable<InventoryOutputDetailModel> {
    return this._httpClient.delete<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.DeleteSalesRemissionDetail}/${inventoryOutputDetailId}`);
  }

  deleteSomeDetails(inventoryOutputDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.DeleteSomeDetails}`,
      inventoryOutputDetailIds);
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.ExportDetailConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllSalesRemissionDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.GetAllSalesRemissionDetailsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.GetColumnsForCaptureTableAsync}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.GetColumnsForDetailConsultationAsync}`);
  }

  getColumnsForListStocksInShopByInventory(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.GetColumnsForListStocksInShopByInventoryAsync}`);
  }

  getListStocksInShopByInventoryAsync(inventoryOutputId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<RentalStockModel>> {
    const params = new HttpParams().set('inventoryOutputId', inventoryOutputId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<RentalStockModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.GetListStocksInShopByInventoryAsync}`,
      filters, { params: params }
    );
  }

  getSalesRemissionDetailById(inventoryOutputDetailId: number): Observable<InventoryOutputDetailModel> {
    return this._httpClient.get<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.GetSalesRemissionDetailById}/${inventoryOutputDetailId}`);
  }

  getSalesRemissionDetailByKeys(storeId: number, articleId: number, inventoryOutputId: number): Observable<InventoryOutputDetailModel> {
    const params = new HttpParams().set('storeId', storeId).set('articleId', articleId).set('inventoryOutputId', inventoryOutputId);
    return this._httpClient.get<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.GetSalesRemissionDetailByKeys}`,
      { params }
    );
  }

  getSalesRemissionDetailsForCaptureTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, inventoryOutputId: number): Observable<PagedResponseModel<InventoryOutputDetailCaptureTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('inventoryOutputId', inventoryOutputId);
    return this._httpClient.get<PagedResponseModel<InventoryOutputDetailCaptureTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.GetSalesRemissionDetailsForCaptureTable}`,
      { params: params }
    );
  }

  getStocksByArticleIdStoreId(rentalStockModel: RentalStockModel): Observable<number> {
    return this._httpClient.post<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.GetStocksByArticleIdStoreId}`,
      rentalStockModel);
  }

  updateSalesRemissionDetail(inventoryOutputDetailContract: InventoryOutputDetailModel): Observable<InventoryOutputDetailModel> {
    return this._httpClient.put<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.salesRemissionDetail.UpdateSalesRemissionDetail}`,
      inventoryOutputDetailContract);
  }
}
